import moment from 'moment';

export const date = (date) => {
  return date
    ? moment(date).format('DD/MM/YYYY')
    : "N/A"
}



// WEBPACK FOOTER //
// ./src/utils/date.js